// NewCustomer.jsx
import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import { useNavigate, useParams } from 'react-router-dom'
import Spinner from '../../util/spinner-shim'

import NavigationBar from '../partials/NavigationBar'
import Footer from '../partials/Footer'
import ModemReplacement from '../partials/SettingPageComponents/ModemReplacementComponents/ModemReplacementContainer'
import withAppStore from '../../util/withAppStore'

import AppStore from '../../stores/AppStore'
import styles from '../../../css/home.module.css'
import GridList from '../partials/GridList'
import AppDispatcher from '../../dispatchers/AppDispatcher'

const dispatch = (action, obj = {}) => AppDispatcher.dispatch({ action, ...obj })

function ModemReplacementPage (props) {
  const navigate = useNavigate()
  const { deviceID, customerID } = useParams()

  const [state, setState] = React.useState({
    page: 1,
    maxPage: 4,
    skipInit: false,
  })

  const statusUpdateOnce = React.useRef(true)

  const goTo = React.useCallback((x) => navigate(x), [navigate])

  const getNewData = React.useCallback(() => {
    dispatch('get-device', { deviceID })
  }, [deviceID])

  const setSkipInit = React.useCallback(() => {
    const { skipInit } = state
    if (!skipInit) {
      setState(prevState => ({ ...prevState, skipInit: true, page: 4 }))
    }
  }, [state])

  const nextPage = React.useCallback(() => {
    const { maxPage, page } = state
    window.scrollTo(0, 0)
    setState(prevState => ({
      ...prevState,
      page: page + 1,
      maxPage: Math.max(maxPage, page + 1)
    }))
  }, [state])

  const pageSelector = React.useCallback((page) => (e) => {
    if (e) {
      e.preventDefault()
    }
    setState(prevState => ({ ...prevState, page }))
    return false
  }, [])

  const goBack = React.useCallback(() => {
    goTo(`/${customerID}/devices/${deviceID}/settings`)
  }, [customerID, deviceID, goTo])

  const submitFinished = React.useCallback(() => {
    goTo(`/${customerID}/devices/${deviceID}/settings`)
  }, [customerID, deviceID, goTo])

  const previousPage = React.useCallback(() => {
    const { page, skipInit } = state
    if (page === 1) {
      goBack()
    } else if (skipInit) {
      setState(prevState => ({
        ...prevState,
        page: 1,
        skipInit: false,
      }))
    } else {
      setState(prevState => ({
        ...prevState,
        page: page - 1,
      }))
    }
  }, [state, goBack])

  React.useEffect(() => {
    getNewData()
  }, [getNewData])

  React.useEffect(() => {
    const { data: { pollInterval } } = props
    const interval = setInterval(getNewData, pollInterval)
    return () => clearInterval(interval)
  }, [getNewData, props.data?.pollInterval])

  const {
    auth: {
      logout,
    },
    auth,
    route: {
      path,
    },
    intl: {
      formatMessage,
    },
    data,
    data: {
      lookupReady,
      lookup,
    } = {},
  } = props

  const device = lookupReady && lookup[deviceID]
  const devices = [device]

  const { page, currentData } = state
  const { id: customerIDFromStore } = AppStore.getCustomer()
  const tileInfo = 'default'

  const MODEM_REPLACEMENT = formatMessage({
    id: 'customer.modemReplacement.modemSwap',
    defaultMessage: 'Modem Swap',
    description: 'Modem Swap label',
  })

  const subject = device
    ? (
      <div className={styles.pageWidth}>
        <div>
          <ModemReplacement
            user={AppStore.getUser()}
            devices={device}
            auth={auth}
            data={data}
            params={{ deviceID, customerID }}
            customerID={customerIDFromStore}
            nextPage={nextPage}
            previousPage={previousPage}
            pageSelector={pageSelector}
            page={page}
            currentData={currentData}
            setSkipInit={setSkipInit}
            submitFinished={submitFinished}
          />
        </div>
      </div>
      )
    : (
      <div className='loading'>
        <Spinner name='double-bounce' />
      </div>
      )

  return (
    <div>
      <Helmet><title>{MODEM_REPLACEMENT}</title></Helmet>
      <NavigationBar
        backFunc={previousPage}
        page={path}
        name={MODEM_REPLACEMENT}
        logOut={() => logout(navigate)}
          // rightControl={trashCan}
      />
      <div className={styles.pageWidth}>
        <div>
          <div className={styles.pageContainer}>
            <section>
              <GridList devices={devices} selectMode={false} tileInfo={tileInfo} />
              {subject}
            </section>
            <br />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

ModemReplacementPage.propTypes = {
  auth: PropTypes.object,
  route: PropTypes.object,
  intl: PropTypes.object,
  data: PropTypes.object,
}

export default withAppStore(injectIntl(ModemReplacementPage))
